import { render, staticRenderFns } from "./change_discounts.vue?vue&type=template&id=8a08a5ae&scoped=true"
import script from "./change_discounts.vue?vue&type=script&lang=js"
export * from "./change_discounts.vue?vue&type=script&lang=js"
import style0 from "./change_discounts.vue?vue&type=style&index=0&id=8a08a5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a08a5ae",
  null
  
)

export default component.exports